<template>
  <div>
    <common-dialog
      ref="dialog"
      width="1300px"
      title="查看 入库单"
      id-key="RecordId"
      :get-data-func="api.info"
      @details-opened="onDetailsOpened"
      @closed="onClosed"
    >
      <template slot="form">
        <div class="box-header">基础信息</div>
        <div class="box">
          <el-row>
            <el-col :span="isMB ? 24 : 8">
              <el-form-item label="入库单号" prop="IndocCode">
                {{ data.IndocCode }}
              </el-form-item>
            </el-col>
            <el-col :span="isMB ? 24 : 8">
              <el-form-item label="入库日期" prop="IndocDate">
                {{ $commonJs.toDateString(data.IndocDate) }}
              </el-form-item>
            </el-col>
            <el-col :span="isMB ? 24 : 8">
              <el-form-item label="入库仓库" prop="WhId">
                {{ data.WhName }}
              </el-form-item>
            </el-col>
            <!-- <el-col :span="isMB ? 24 : 8" v-if="loginInfo.UserType == 0">
              <el-form-item label="所属商家" prop="StoreId">
                <busi-select
                  v-model="data.StoreId"
                  ref="busiSelect" 
                  :disabled="true"
                  :checkState="2"
                ></busi-select>
              </el-form-item>
            </el-col> -->
          </el-row>
        </div>
        <div class="box-header">
          <span>入库明细</span>
        </div>
        <el-table border :data="data.Goods" highlight-current-row>
          <el-table-column
            prop="GoodsName"
            label="商品名称"
            min-width="260px"
            show-overflow-tooltip
          />
          <el-table-column
            prop="GoodsCode"
            label="商品编码"
            min-width="110px"
          />
          <el-table-column
            prop="AttributeName"
            label="规格型号"
            min-width="110px"
          />
          <el-table-column
            prop="AttributeCode"
            label="货号"
            min-width="110px"
          />
          <el-table-column prop="TypeName" label="商品分类" min-width="110px" />
        <!--  <el-table-column
            prop="GoodsModel"
            label="规格型号"
            min-width="100px"
          />-->
          <el-table-column prop="MainUnitName" label="单位" min-width="80px" />
          <el-table-column prop="InCount" label="数量" min-width="100px" />
          <el-table-column prop="InPrice" label="单价" min-width="100px" />
          <el-table-column prop="InAmount" label="金额" min-width="100px" />
        </el-table>
      </template>
      <template slot="footer">
        <template v-if="$permission.canReview()">
          <template v-if="data.State == 1">
            <el-button type="success" @click="pass">通 过</el-button>
            <el-button type="danger" @click="noPass">不通过</el-button>
          </template>
          <el-button type="warning" v-else-if="data.State == 2" @click="cancel"
            >撤销审核</el-button
          >
        </template>
        <el-button @click="close">关闭</el-button>
      </template>
    </common-dialog>
  </div>
</template>

<script>
import editDialogMixin from "@/mixins/editDialog";
import commonDialog from "@/components/common/dialog";
import storeSelect from "@/components/shop/store/select";
import busiSelect from "@/components/shop/business/select";

export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog,
    storeSelect,
    busiSelect
  },
  data() {
    return {
      data: {
        RecordId: 0,
        IndocCode: "",
        IndocDate: this.$commonJs.getToday(),
        WhId: null, //仓库
        WhName: "",
        State: 0, //0草稿，1待审，2通过，3不通过，4作废
        Goods: [],
      },
      api: require("@/api/wh/indoc").default,
      isMB: this.$store.state.isMB,
      loginInfo: JSON.parse(localStorage.getItem("loginInfo")),
      checkState:2
    };
  },
  methods: {
    onDetailsOpened(data) {
      this.data = { ...this.data, ...data };
      console.log("data", this.data);
    },
    pass() {
      this.$confirm("确认通过吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.loading(true);
          this.api.pass(this.data.RecordId).then((res) => {
            this.loading(false);
            if (res.Code == 0) {
              this.$message.success(res.Msg);
              this.$emit("close-saved");
              this.close(true);
            } else {
              this.$message.error(res.Msg);
            }
          });
        })
        .catch(() => {});
    },
    noPass() {
      this.$confirm("确认不通过吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.loading(true);
          this.api.noPass(this.data.RecordId).then((res) => {
            this.loading(false);
            if (res.Code == 0) {
              this.$message.success(res.Msg);
              this.$emit("close-saved");
              this.close(true);
            } else {
              this.$message.error(res.Msg);
            }
          });
        })
        .catch(() => {});
    },
    cancel() {
      this.$confirm("确认撤销审核吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.loading(true);
          this.api.cancelReview(this.data.RecordId).then((res) => {
            this.loading(false);
            if (res.Code == 0) {
              this.$message.success(res.Msg);
              this.$emit("close-saved");
              this.close(true);
            } else {
              this.$message.error(res.Msg);
            }
          });
        })
        .catch(() => {});
    },
    onClosed() {
      this.data.Goods = [];
    },
  },
};
</script>